import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 39,
  medium: 29,
  small: 19,
  xSmall: 16
};
const UnMuteIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.78 15.0001C19.78 13.3719 18.7506 11.9841 17.3071 11.4522L17.6806 10.4385C19.5365 11.1224 20.86 12.9067 20.86 15.0001C20.86 17.0934 19.5365 18.8777 17.6806 19.5616L17.3071 18.548C18.7506 18.016 19.78 16.6282 19.78 15.0001Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.1744 23.6164L18.801 22.6027C21.8941 21.4627 24.1 18.489 24.1 15.0001C24.1 11.5111 21.8941 8.53737 18.801 7.39741L19.1744 6.38372C22.68 7.67568 25.18 11.0459 25.18 15.0001C25.18 18.9542 22.68 22.3244 19.1744 23.6164Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M20.6683 27.6711L20.2948 26.6574C25.0377 24.9095 28.42 20.3498 28.42 15.0001C28.42 9.65034 25.0377 5.09061 20.2948 3.34267L20.6683 2.32898C25.8236 4.22892 29.5 9.18515 29.5 15.0001C29.5 20.815 25.8236 25.7712 20.6683 27.6711Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5 5.12455V24.8756L7.254 20.6011L0.5 20.6015V9.3986L7.254 9.39806L14.5 5.12455ZM13.5 23.1241V6.87505L7.52837 10.3986L1.5 10.3981V19.6011L7.52837 19.6015L13.5 23.1241Z",
        fill: "currentColor"
      }
    )
  );
};
UnMuteIcon.iconName = "UnMuteIcon";

export { UnMuteIcon };
